webpackJsonp([13],{

/***/ "./school-profile.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__("../../node_modules/ramda/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ramda__);


var setStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["curry"])(function (key, value, el) {
    el.style[key] = value;
    return el;
});

var getStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["curry"])(function (key, el) {
    return el.style[key];
});

var addClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["curry"])(function (className, el) {
    return el && el.classList.add(className);
});
var removeClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["curry"])(function (className, el) {
    return el && el.classList.remove(className);
});
var hasClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["curry"])(function (className, el) {
    return el && el.classList.contains(className);
});
var toggleClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["curry"])(function (className, el) {
    return hasClass(className, el) ? removeClass(className, el) : addClass(className, el);
});

window.aboundSchoolSubTabs = function (selectedPlaceholderEl, menuEl, menuItemEls, subProgramLinks) {
    if (!selectedPlaceholderEl || !menuEl || !menuItemEls) return;
    var open = addClass('open');
    var close = removeClass('open');
    var isOpen = hasClass('open');
    var unselect = removeClass('selected');
    var select = addClass('selected');
    var isSelected = hasClass('selected');
    var unselectAll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["map"])(unselect);
    var getContentEl = function getContentEl(el) {
        return document.getElementById(el.dataset.contentId);
    };
    var getAllContentEls = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["map"])(getContentEl);
    var contentEls = getAllContentEls(menuItemEls);

    var scrollTo = function scrollTo(el) {
        var scrollToY = el.getBoundingClientRect().top + window.scrollY;
        window.scrollTo(0, scrollToY);
    };

    var openMenu = function openMenu() {
        open(menuEl);
        setTimeout(function () {
            return document.body.addEventListener('click', closeMenu);
        }, 1); // close if the body is clicked
    };

    var closeMenu = function closeMenu() {
        close(menuEl);
        document.body.removeEventListener('click', closeMenu);
    };

    var onItemClick = function onItemClick(e) {
        e.stopPropagation(); // if we don't do this, the menu will get a click event after we've closed the menu and it will open itself again

        // handle the menu
        unselectAll(menuItemEls);
        select(e.currentTarget);
        selectedPlaceholderEl.innerText = e.currentTarget.innerText;

        closeMenu(menuEl);

        // handle the contents
        unselectAll(contentEls);
        select(getContentEl(e.currentTarget));
    };

    var onMenuClick = function onMenuClick() {
        isOpen(menuEl) ? closeMenu(menuEl) : openMenu(menuEl);
    };

    var onSubProgramLinkClick = function onSubProgramLinkClick(e) {
        e.preventDefault();
        e.stopPropagation();
        var menuItemId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["pathOr"])(null, ['dataset', 'programLinkId'], e.currentTarget);
        if (!menuItemId) return;

        var menuItemEl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["head"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["filter"])(function (x) {
            return x.id === menuItemId;
        }, menuItemEls));
        if (!menuItemEl) return;

        menuItemEl.click();
        scrollTo(menuEl);
    };

    menuEl.addEventListener('click', onMenuClick);
    menuItemEls.forEach(function (el) {
        return el.addEventListener('click', onItemClick);
    });
    subProgramLinks && subProgramLinks.forEach(function (el) {
        return el.addEventListener('click', onSubProgramLinkClick);
    });
};

window.aboundSchoolTabs = function (tabEls, moreButtonEl, moreTitlesEl) {
    var hide = removeClass('selected');
    var show = addClass('selected');
    var isShown = hasClass('selected');
    var hideAll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["map"])(hide);
    var getContentEl = function getContentEl(tabEl) {
        return document.getElementById(tabEl.dataset.contentId);
    };
    var getAllContentEls = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["map"])(getContentEl);

    var contentEls = getAllContentEls(tabEls);

    var onBodyClick = function onBodyClick(_ref) {
        var target = _ref.target;

        if (target == moreTitlesEl) return;else hideMoreMenu();
    };

    var hideMoreMenu = function hideMoreMenu() {
        hide(moreTitlesEl);
        hide(moreButtonEl);
        document.body.removeEventListener('click', onBodyClick);
    };

    var showMoreMenu = function showMoreMenu() {
        show(moreTitlesEl);
        show(moreButtonEl);
        setTimeout(function () {
            return document.body.addEventListener('click', onBodyClick);
        }, 1); // close if the body is clicked
    };

    var tabOnClick = function tabOnClick(_ref2) {
        var currentTarget = _ref2.currentTarget;

        // hide all
        hideAll(tabEls);
        hideAll(contentEls);

        // show selected
        show(currentTarget);
        show(getContentEl(currentTarget));

        // hide the menu if it's open
        hideMoreMenu();
    };

    var moreButtonOnClick = function moreButtonOnClick() {
        isShown(moreButtonEl) ? hideMoreMenu() : showMoreMenu();
    };

    moreButtonEl && moreButtonEl.addEventListener('click', moreButtonOnClick);
    tabEls && tabEls.length && tabEls.forEach(function (e) {
        return e.addEventListener('click', tabOnClick);
    });
};

window.aboundShowMore = function (showMoreEl, theRestEls, animationTransitionTimeMs) {
    theRestEls = theRestEls.length === undefined ? [theRestEls] : theRestEls;

    var grow = function grow() {
        showMoreEl.removeEventListener('click', grow);
        showMoreEl.remove();

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["map"])(setStyle('maxHeight', '500px'), theRestEls);

        setTimeout(function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["map"])(setStyle('maxHeight', 'none'), theRestEls);
        }, animationTransitionTimeMs);
    };

    showMoreEl.addEventListener('click', grow);
};

window.aboundStoreHeight = function (el, cssVar) {
    var storeHeight = function storeHeight() {
        return document.documentElement.style.setProperty(cssVar, window.getComputedStyle(el).height);
    };
    window.addEventListener('resize', storeHeight);
    storeHeight();
};

/***/ })

},["./school-profile.js"]);


// WEBPACK FOOTER //
// scripts/school-profile.d075e11b60a6b8e95314.js